<template>
  <div class="bindList">
    <div class="boundAcc accBindIndex-item">
      <p class="title">
        已绑定账号
        <span class="under_line"></span>
      </p>
      <div class="acc-list">
        <div class="acc-item">
          <p>手机号：{{userInfo.mobile | hiddenPhoneNum}}</p>
          <span
            class="toChangePhone blueBtn"
            :class="{unAble:blueLikeAble}"
            v-if="userInfo.mobile"
            @click="toChangePhone()"
          >修改登录手机</span>
        </div>
        <div class="acc-item" v-if="userInfo.email">
          <p>邮 箱：{{userInfo.email}}</p>
        </div>
      </div>
    </div>
    <div class="bindsocailAcc accBindIndex-item">
      <p class="title">
        绑定社交账号
        <span class="under_line"></span>
      </p>
      <div class="acc-list" v-if="showList">
        <div class="acc-item">
          <p>
            <i class="icon wechat"></i>微信
          </p>
          <span
            class="bind blueBtn"
            :class="{noBind:wechatBind,unAble:blueLikeAble}"
            @click="socialJump('wechat',wechatBind)"
          >{{wechatBind?(wechatNick?wechatNick:"解除绑定"):"绑定账号"}}</span>
        </div>
        <div class="acc-item">
          <p>
            <i class="icon weibo"></i>微博
          </p>
          <span
            class="bind blueBtn"
            :class="{noBind:weiboBind,unAble:blueLikeAble}"
            @click="socialJump('weibo',weiboBind)"
          >{{weiboBind?(weiboNick?weiboNick:"解除绑定"):"绑定账号"}}</span>
        </div>
        <div class="acc-item">
          <p>
            <i class="icon qq"></i>QQ
          </p>
          <span
            class="bind blueBtn"
            :class="{noBind:qqBind,unAble:blueLikeAble}"
            @click="socialJump('qq',qqBind)"
          >{{qqBind?(qqNick?qqNick:"解除绑定"):"绑定账号"}}</span>
        </div>
        <!-- <div class="acc-item">
          <p>
            <i class="icon people"></i>人民网
          </p>
          <span
            class="bind blueBtn"
            :class="{noBind:peopleBind,unAble:blueLikeAble}"
            @click="socialJump('people',peopleBind)"
          >{{peopleBind?(peopleNick?peopleNick:"解除绑定"):"绑定账号"}}</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import user from "@/api/user";
import Bus from '@/utils/Bus.js'

export default {
  name: "bindList",
  components: {},
  data() {
    return {
      wechatBind: false,
      weiboBind: false,
      qqBind: false,
      peopleBind: false,
      wechatNick: "",
      weiboNick: "",
      qqNick: "",
      peopleNick: "",
      blueLikeAble: false,
      showList: false
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    toChangePhone() {
      if (this.blueLikeAble) {
        return;
      }
      this.$router.push({ name: "editPhone" });
    },
    handBind(bool) {
      // if (bool) {
      // }
    },
    socialJump(where, cancelBind) {
      if (this.blueLikeAble) {
        return;
      }
      if (cancelBind) {
        this.$MessageBox
          .confirm("确定解绑当前社交账号？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          })
          .then(() => {
            user
              .unBindSocialAcc(where, { driver: where })
              .then(result => {
                this.$Message.success(result.data.message);
                setTimeout(() => {
                  location.reload();
                }, 1000);
              })
              .catch(err => {
                console.log(err);
              });
          })
          .catch(action => {
            console.log(action);
          });
      } else {
        window.location.href = this.varHost + "uc/bind-socialite/" + where;
      }
    }
  },
  created() {
    //修改手机实时
    Bus.$on('changePhone',(phone)=>{
        // console.log(phone)
        this.userInfo.mobile = phone
    })
  },
  watch: {
    userInfo: {
      handler(newVal, OldVal) {
        if (newVal.id) {
          for (let i = 0; i < newVal.socialite_users.length; i++) {
            const element = newVal.socialite_users[i];
            if (element.driver) {
              if (element.driver == "wechat") {
                this.wechatBind = true;
                this.wechatNick = element.nickname;
              } else if (element.driver == "weibo") {
                this.weiboBind = true;
                this.weiboNick = element.nickname;
              } else if (element.driver == "qq") {
                this.qqBind = true;
                this.qqNick = element.nickname;
              } else if (element.driver == "people") {
                this.peopleBind = true;
                this.peopleNick = element.nickname;
              }
            }
          }
          this.showList = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  props: {
    userInfo: {
      type: Object,
      default: {}
    }
  },
  mounted() {},
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>
.bindList {
  .accBindIndex-item {
    margin-top: 50px;
    width: 640px;
    padding: 0 40px;
    .title {
      height: 50px;
      line-height: 50px;
      font-size: 20px;
      font-weight: 700;
      position: relative;
      padding: 0 90px;
      .under_line {
        width: 60px;
        height: 2px;
        position: absolute;
        bottom: 0;
        left: 90px;
        background-color: orange;
      }
    }
    .acc-list {
      border-top: 1px solid #ccc;
      padding: 40px 90px 0;

      .acc-item {
        width: 460px;
        height: 50px;
        background-color: #f2f2f2;
        margin-bottom: 15px;
        border-radius: 4px;
        position: relative;
        p {
          height: 50px;
          line-height: 50px;
          font-size: 16px;
          padding: 0 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .bind,
        .toChangePhone {
          width: 130px;
          height: 26px;
          position: absolute;
          right: 10px;
          top: 12px;
          background-color: #4981f2;
          border-radius: 15px;
          text-align: center;
          line-height: 26px;
          color: #fff;
          cursor: pointer;
          font-size: 14px;
        }
        .icon {
          width: 30px;
          height: 24px;
          margin-top: 14px;
          margin-right: 15px;
          float: left;
        }
        .wechat {
          background: url("../../../assets/images/WeiXin.png") no-repeat center;
        }
        .weibo {
          background: url("../../../assets/images/WeiBo.png") no-repeat center;
        }
        .qq {
          width: 24px;
          height: 28px;
          margin-top: 11px;
          margin-right: 18px;
          margin-left: 3px;
          background: url("../../../assets/images/QQ.png") no-repeat center;
        }
        .people {
          width: 30px;
          height: 30px;
          margin-left: 3px;
          background: url("../../../assets/images/people.png") no-repeat center/cover;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/accBind/bindList.vue